<template>
  <v-app>
    <router-view />
    <vue-progress-bar />
    <notifications />
  </v-app>
</template>

<script>
import { useHead } from '@unhead/vue'

export default {
  name: 'App',
  setup () {
    useHead({
      title: 'Tapapp',
      titleTemplate: '%s'
    })
  }
}
</script>

<style lang="scss">
@import "./assets/css/scss/components.scss";
@import "./assets/css/scss/style.scss";
</style>
